import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '@environments/environment';
import { ResponseResult } from '@app/auth/model';
import { Injectable } from '@angular/core';
import { Indication } from '../../student/model';

@Injectable({
  providedIn: 'root'
})
export class IndicationService {
  private route: string = "marketing";
  private controller: string = "contactbysite";
  private endpointPrefix: string;

  constructor(private http: HttpClient) {
    this.endpointPrefix = `${environment.urlAPI}/${this.route}/${this.controller}`;
  }

  getByIndication(userGuid: string): any {
    return this.http.get<ResponseResult>(`${this.endpointPrefix}/getAllIndicationsByUserGuid/${userGuid}`);
  }

  getAllIndicationsForAdmin(): any {
    return this.http.get<ResponseResult>(`${this.endpointPrefix}/GetAllIndicationsForAdmin`);
  }

  getById(id: string): any {
    let params = new HttpParams();
    params = params.append('id', id);
    return this.http.get<ResponseResult>(`${this.endpointPrefix}/getById`, {params: params});
  }

  save(indication: Indication): any {
    return this.http.post<ResponseResult>(`${this.endpointPrefix}/indication`, indication);
  }
}
